// Deprecated. Import from 'metadata.js' directly instead.
export { getCountryCallingCode as default } from './metadata';
//# sourceMappingURL=getCountryCallingCode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/es6/getCountryCallingCode.js
// module id = n5E4
// module chunks = 0